// Single source of truth for "a default discount is going to be auto-applied,
// but the validate/apply call has not resolved yet." This was previously
// duplicated as isDefaultDiscountApplyPending (Remittance ver2) and
// isDefaultAutoApplyPending (withDiscountAutoApply) with divergent guards.
//
// Callers pass already-computed booleans so each site keeps its own signal
// sources (e.g. the parent's isCurrentDiscountsLoaded vs the HOC's
// hasLoadedDiscounts, or truthy discountDefault vs !isEmpty(discountDefault)).
// Guards a caller does not currently apply are left at their neutral value
// (isDisabled = false, isReady = true), which preserves that caller's prior
// result exactly. Reconciling the guard sets so both sites gate identically is
// a separate, behaviour-changing slice (see .repo-tmp) that requires a visual
// smoke; this module only removes the duplication.
//
// Pure and dependency-light so it stays unit-testable under jsdom.
export const getIsDefaultAutoApplyPending = ({
  discountsLoaded,
  hasDefault,
  isApplied,
  hasFailure,
  isBlocked,
  isDisabled = false,
  isReady = true,
} = {}) =>
  Boolean(
    discountsLoaded &&
      hasDefault &&
      !isApplied &&
      !hasFailure &&
      !isBlocked &&
      !isDisabled &&
      isReady,
  );
